import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=72f9b1a2&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=72f9b1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9b1a2",
  null
  
)

export default component.exports